module.exports = __webpack_public_path__ + "2bc51ce397299227cd4d6a24b983ee19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/images_en/home-notice-pic.jpg
// module id = 1127
// module chunks = 0